import React from 'react';
import '../fundo_liquido/style.css';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { TIPOS_ATIVO } from './camposConfig';

const TiposAtivo: React.FC = () => {
  const navigate = useNavigate();
  const tipos = Object.values(TIPOS_ATIVO);

  return (
    <div className="av-page">
      <header className="av-header">
        <div>
          <h1 className="av-title">Cadastro de ativos</h1>
          <p className="av-sub">Escolha o tipo de ativo para cadastrar.</p>
        </div>
      </header>

      <section className="av-card">
        {tipos.length === 0 ? (
          <p className="av-sub">Nenhum tipo de ativo configurado ainda.</p>
        ) : (
          <ul className="av-tipos">
            {tipos.map((t) => (
              <li key={t.tipo}>
                <button className="av-tipo-row" type="button" onClick={() => navigate(`/cadastro/ativo/${t.tipo}`)}>
                  <span className="av-tipo-grupo">{t.grupoLabel}</span>
                  <span className="av-tipo-label">{t.label}</span>
                  <span className="av-tipo-chev">›</span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
};

export default TiposAtivo;
